import { PrintTypesMap } from '@/types';
import { getParams } from '@/utils/params';
import { Embroidery, Flex } from '@/model/printType/printTypes';

const blockedDigitalColors = [
  '17', // neon yellow
  '70', // gold-metallic
  '71', // silver-metallic
  '75', // neon green
  '76', // neon orange
  '165', // neon pink
];

export const getColorsForDigitalPrintTypes = (printTypes: PrintTypesMap) =>
  (
    (getParams().printTypeIdForDigitalColors &&
      printTypes.get(getParams().printTypeIdForDigitalColors!)) ||
    printTypes.get(Flex) ||
    printTypes.get(Embroidery)
  )?.colors
    .filter((c) => !blockedDigitalColors.includes(c.id))
    .map(({ fill, name }) => ({ fill, name })) || [];
